var url = "8977a08a5e3c3bc353611066d1d7f548.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;